var exports = {
  "k": "x61f99309--a8b611--container",
  "r": "x61f99309--a8b611--body",
};

module.exports = exports;
